import EmailTemplatesGrid from "@/app/shared/email-templates";
import PageHeader from "@/app/shared/page-header";
import { metaObject } from "@/config/site.config";
import { Link } from "react-router-dom";
import { Button } from "rizzui";

export const metadata = {
    ...metaObject("Email Templates"),
};

const pageHeader = {
    title: "Email Templates",
    breadcrumb: [
        {
            href: "/",
            name: "Home",
        },
        {
            name: "Email Templates",
        },
    ],
};

export default function EmailTemplates() {
    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <Link to="https://react.email/" target="_blank">
                    <Button as="span">Learn More</Button>
                </Link>
            </PageHeader>
            <EmailTemplatesGrid />
        </>
    );
}
